var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p-navigation-drawer'),_c('p-app-bar'),_c('v-main',{staticClass:"mx-lg-6 mt-4"},[_c('v-container',{attrs:{"fluid":!_vm.$vuetify.breakpoint.xl}},[_c('router-view')],1)],1),_c('p-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }